import {constants, database} from 'lib_ui-services';
import editRule from '../../namespace/relation/doingEdit_namespace_relation';

export default {
    verb: 'doingView',
    namespace: 'order',
    relation: 'order',
    priority: 10,
    description: 'View an order record with random selection support',
    logic: viewOrder
};

async function viewOrder(params) {
    const { data, context, dispatch } = params;
    const { namespace, relation, type } = context;

    if (type === 'random') {
        const db = database.get();
        const persistContext = { ...context, verb: 'persist', eventId: undefined };
        const results = await db.find({ 'meta.deleted': { $exists: false } }, persistContext);
        const records = (results || []).filter(r => r._id && r.title)
            // Only include records that are suspended or in any form of in progress.
            .filter(r => (/suspended|in progress/i).test(r['order:status']?.title));

        if (records.length === 0) {
            dispatch(
                {
                    // "open" orders in this case does not include New or Closed* orders.
                    message: 'No open orders found.',
                    timeout: 5000,
                    variant: 'info',
                    type: constants.notificationTypes.TOAST
                },
                { verb: 'pop', namespace: 'application', relation: 'notification' }
            );
            return { activationVerb: 'view', record: undefined, isNew: false, namespace, relation, type };
        }

        const record = records[Math.floor(Math.random() * records.length)];
        return { activationVerb: 'view', record, isNew: false, namespace, relation, type };
    }

    // AutoRefresh case: DetailPane triggers view with no _id/record after upsert success.
    // Nothing to view specifically — the upsert already updated the local DB and list.
    if (!data?._id && !data?.record && !data?.activeRecord) {
        return { activationVerb: 'view', record: undefined, isNew: false, namespace, relation, type };
    }

    // Normal view with a specific record: delegate to the generic edit/view logic
    const result = await editRule.logic(params);
    result.activationVerb = 'view';
    return result;
}
